import React, { Component } from 'react';
import _ from 'lodash';
import { parseStringParam, dpath, shallowEqual } from '../../utils/shared';
import { donorsIncluded } from '../../utils/donorHelpers';
import { connect } from 'react-redux';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import DonorFullPage from '../../Components/Donor/DonorFullPage';
// import VerticalVideoSync from '../../containers/VerticalVideoSync';
class DonorListPassive extends Component {

  constructor(props) {
    super(props);

    this.state = {
      donorData: null,
      cycleIndex: 0,
      showDonors: true,
      showSlides: false,
      slideImage: "",
      parentCategoryName: "", //state based to support setting to empty string on fades
      subCategoryname: "",
      subCategorySubheader: "",
      subCategoryDescription: ""
    }
    this._categoryCurrent = -1;
    this._endOfDonorLoop = true;
    this._donors = null;
    this._manualSlidesIndex = 0; //which manual slide entry
    this._manualSlidesInnerIndex = -1; //which manual slide within entry

    //defaults
    this._columns = 3;
    this._rows = 8;
    this._fontColor = "#ffffff";
    this._backdropColor = "#000000";
    this._footerText = "";
    this._parentCategoryName = ""; //used to stash name so state can switch to empty string
    this._ni_options = {};
    this._metaCycleTimeout = null;
    this._listCycleTime = 8000;
    this._marginRight = this.props.screen.sv.width * 0.0375;



    this._parentCategoryNameStyle = {};
    this._subCategoryNameStyle = {};
    this._subCategorySubheaderStyle = {};
    this._subCategoryDescriptionStyle = {};
    this._nameListStyle = {};
    this._footerTextStyle = {};

    this._parentCategoryNameOffset = {};
    this._subCategoryNameOffset = {};
    this._subCategorySubheaderOffset = {};
    this._subCategoryDescriptionOffset = {};
    this._nameListOffset = {};
    this._footerTextOffset = {};
    this._titleDividerLineOffset = {};
    this._nameListHeight = 0;
    this._resetLoopOnStart = true;

    //safe overrides
    if (_.has(this.props.module, 'contents.ni_options')) {
      this._ni_options = this.props.module.contents.ni_options;
      this._resetLoopOnStart = this._ni_options.resetInsertLoop;
      this.setFontAttributes(this._parentCategoryNameStyle, this.props.module.contents.ni_options.format.parent_category_name);
      this.setFontAttributes(this._subCategoryNameStyle, this.props.module.contents.ni_options.format.sub_category_name);
      this.setFontAttributes(this._subCategorySubheaderStyle, this.props.module.contents.ni_options.format.sub_category_subheader);
      this.setFontAttributes(this._subCategoryDescriptionStyle, this.props.module.contents.ni_options.format.sub_category_description);
      this.setFontAttributes(this._nameListStyle, this.props.module.contents.ni_options.format.name_list);
      this.setFontAttributes(this._footerTextStyle, this.props.module.contents.ni_options.format.footer_text);
      this._sumH = this.props.module.contents.ni_options.topMargin * .01 * this.props.screen.screenHeight; //adjust for base offset
      this.setOffset(this._parentCategoryNameOffset, this.props.module.contents.ni_options.format.parent_category_name, 0);
      this.setOffset(this._subCategoryNameOffset, this.props.module.contents.ni_options.format.sub_category_name, 0);
      this.setOffset(this._subCategorySubheaderOffset, this.props.module.contents.ni_options.format.sub_category_subheader, 0);
      this.setOffset(this._subCategoryDescriptionOffset, this.props.module.contents.ni_options.format.sub_category_description, 0);
      this._titleDividerLineOffset.val = this._sumH;
      this.setOffset(this._nameListOffset, this.props.module.contents.ni_options.format.name_list, this.props.module.contents.ni_options.dividerLineMargin);
      this._footerTextOffset.val = this.props.screen.screenHeight - this.props.module.contents.ni_options.format.footer_text.height * .01 * this.props.screen.screenHeight;
    }
    if (_.has(this.props.module, 'contents.ni_options.columns')) {
      this._columns = this.props.module.contents.ni_options.columns;
    }
    if (_.has(this.props.module, 'contents.ni_options.rows')) {
      this._rows = this.props.module.contents.ni_options.rows;
    }
    if (_.has(this.props.module, 'contents.ni_options.fontColor')) {
      this._fontColor = this.props.module.contents.ni_options.fontColor;
    }
    if (_.has(this.props.module, 'contents.ni_options.rows')) {
      this._backdropColor = this.props.module.contents.ni_options.backdropColor;
    }
    if (_.has(this.props.module, 'contents.ni_options.footerText')) {
      this._footerText = this.props.module.contents.ni_options.footerText;
    }
    if (_.has(this.props.module, 'contents.cycle_time')) {
      this._listCycleTime = this.props.module.contents.cycle_time * 1000;
    }
    if (_.has(this.props.module, 'contents.ni_options.columnMargin')) {
      this._marginRight = this.props.module.contents.ni_options.columnMargin * 0.01 * this.props.screen.r16_9.width;
    }
  }

  componentWillMount() {
    //checkData(this.props.module);
  }

  componentDidMount() {
    this.initDonors();
    document.addEventListener("keydown", this.handleKeyDown);
    this.metaCycle();
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    clearTimeout(this._metaCycleTimeout);
    this._metaCycleTimeout = null;
  }

  setOffset = (setVar, styleObj, margin) => {
    if (styleObj.visible === true) {
      setVar.val = this._sumH + (margin * .01 * this.props.screen.screenHeight);
      this._sumH += styleObj.height * .01 * this.props.screen.screenHeight;
    }
  }

  setFontAttributes = (styleObj, rootObj) => {
    styleObj.color = rootObj.fontColor;
    styleObj.fontWeight = rootObj.fontWeight;
    styleObj.textAlign = rootObj.justification.toLowerCase();
    styleObj.fontStyle = rootObj.fontStyle.toLowerCase();
    styleObj.fontFamily = rootObj.font;
    styleObj.fontSize = rootObj.fontSize * this.props.screen.screenHeight * .01;
  }

  handleKeyDown = (e) => {
    switch (e.key) {
      case '1':
        this.metaCycle(true);
        break;
      case '6':
        clearTimeout(this._metaCycleTimeout);
        break;
      default:
        break;
    }
  }

  setMetaCycleTimeout(time, cycleIndex) {

    if (this._metaCycleTimeout) {
      clearTimeout(this._metaCycleTimeout)
      this._metaCycleTimeout = null
    }

    this._metaCycleTimeout = setTimeout(() => {
      this.metaCycle(cycleIndex);
    }, time)
  }

  //called for every cycle to determine action
  metaCycle = (cycleIndex) => {
    if (cycleIndex) {
      this.cycleIndex();
    }

    if (this._ni_options.interstitial === false) {

      this.cycleDonorIndex();
      this.setState({
        showDonors: true,
        showSlides: false
      })
      this.setMetaCycleTimeout(this._listCycleTime, true);
    }
    else {
      if (this._ni_options.auto_interstitial === true) {
        //TODO: Implement
        //insert per number of screens
        //this._ni_options.screensBetween;
      }
      else if (this._resetLoopOnStart === true && this._manualSlidesIndex > this._ni_options.manualSlides.length - 1) {
        this.setState({
          showDonors: true,
          showSlides: false
        })
        this.cycleDonorIndex();
        this.setMetaCycleTimeout(this._listCycleTime, true);
      }
      else {
        this._manualSlidesInnerIndex++;
        let slideData = this._ni_options.manualSlides[this._manualSlidesIndex];
        let totalSteps = slideData.screens + slideData.end - slideData.start;
        if (this._manualSlidesInnerIndex < slideData.screens) {
          this.cycleDonorIndex();
          this.setState({
            showDonors: true,
            showSlides: false
          })
          this.setMetaCycleTimeout(this._listCycleTime, true);
        }
        else if (this._manualSlidesInnerIndex <= totalSteps) {
          //cycle through and show slides
          let currentSlideIndex = (slideData.start - 1) + (this._manualSlidesInnerIndex - slideData.screens);
          let dd = this.state.donorData || {};
          dd.name = "";
          this.clearDonorData();
          this.setState({
            slideImage: dpath(this.props.screen.mode, this._ni_options.slideshow_module.contents.images[currentSlideIndex].path, this._ni_options.slideshow_module.contents.images[currentSlideIndex].file_name, this.props.screen.webkey),
            donorData: dd
          })
          let slideTimeOut = this._listCycleTime;
          if (_.has(this._ni_options, 'slideshow_module.contents.cycle_overrides[' + currentSlideIndex + ']')) {
            slideTimeOut = this._ni_options.slideshow_module.contents.cycle_overrides[currentSlideIndex] * 1000;
          }
          this.setMetaCycleTimeout(slideTimeOut, true);
        }
        else {
          this._manualSlidesIndex++;
          //if not resetLoopOnStart end of loop cycle slides
          if (this._resetLoopOnStart === false && this._manualSlidesIndex > this._ni_options.manualSlides.length - 1) {
            this._manualSlidesIndex = 0;
          }
          this._manualSlidesInnerIndex = -1
          this.metaCycle(false); //end of loop recursive
        }


      }
    }
  }

  clearDonorData = () => {
    this.setState({
      showSlides: true,
      showDonors: false,
      parentCategoryName: "",
      subCategoryName: "",
      subCategorySubheader: "",
      subCategoryDescription: "",
    })
  }

  initDonors = () => {
    let includes = [];
    if (_.has(this.props.module, 'contents.include_categories')) {
      includes = this.props.module.contents.include_categories;
    }
    this._donors = donorsIncluded(this.props.donors.donorCategories, includes);
    let cat = this._donors[0];
    let parent = _.find(this.props.donors.donorCategories, { id: Number(cat.parent_category) });

    if (parent) {
      this._parentCategoryName = parent.name;
      this.setState({
        parentCategoryName: parent.name,
        subCategoryName: cat.name,
        subCategorySubheader: cat.subheader,
        subCategoryDescription: cat.description
      })
    }

  }

  shouldComponentUpdate(prevProps, prevState) {
    if (shallowEqual(this.state, prevState)) {
      return false;
    }
    return true;
  }

  //for unique transition keys
  cycleIndex = () => {
    let cycleIndex = this.state.cycleIndex;
    if (cycleIndex === 100) {
      cycleIndex = 0;
    }
    this.setState({
      cycleIndex: ++cycleIndex
    })
  }

  cycleSlideIndex = () => {
    let dd = this.state.donorData
    dd.name = "";
    this.clearDonorData();
    this.setState({
      donorData: dd
    })
  }

  cycleDonorIndex = () => {

    if (this._endOfDonorLoop === true) {
      this._categoryCurrent++;
      this._donorIndex = 0;
      if (this._categoryCurrent === this._donors.length) {
        //end of donor categories, reset entire loop
        this._categoryCurrent = 0;
        if (this._resetLoopOnStart === true) {
          this._manualSlidesIndex = 0; //which manual slide entry
          this._manualSlidesInnerIndex = -1; //which manual slide within entry
          //console.log("EXTRA LOOP");
          this._endOfDonorLoop = false;
          return this.metaCycle(false);
        }
      }
    }

    let total = this._columns * this._rows;
    let start = this._donorIndex * total;
    // USE THIS LOGIC FOR PARENT CATEGORY NAME
    let cat = this._donors[this._categoryCurrent];
    //set to static parent category name
    this.setState({
      parentCategoryName: this._parentCategoryName,
      subCategoryName: cat.name,
      subCategorySubheader: cat.subheader,
      subCategoryDescription: cat.description
    })

    if (!cat.donors[start]) {
      start = 0
      this._donorIndex = 0;
    }

    this._endOfDonorLoop = false;
    let end = start + (total);
    if (!cat.donors[end]) {
      end = cat.donors.length;
      this._endOfDonorLoop = true;
      this._donorIndex = 0;
    }
    else {
      this._donorIndex++
    }

    let donorsSliced = cat.donors.slice(start, end);
    let perColumn = 0;

    //distribute end page logic for empty units in last row
    if (this._endOfDonorLoop === true) {
      let dLength = donorsSliced.length;
      let extraSpaces = 0; //default to 0
      perColumn = Math.ceil(dLength / this._columns);
      if (perColumn * this._columns > dLength) { //extra spaces on last row required
        extraSpaces = (perColumn * this._columns) - dLength;
      }
      let normalSpaces = this._rows - perColumn //spaces to add on each normal row
      let lastSpaces = normalSpaces + extraSpaces //spaces to add on last row

      for (var i = 0; i < this._columns; i++) {
        if (i < (this._columns - 1)) { //rows prior to last
          for (var a = 0; a < normalSpaces; a++) {
            donorsSliced.splice((i * this._rows) + perColumn, 0, { name: "" });
          }
        }
        else {
          for (var b = 0; b < lastSpaces; b++) {
            donorsSliced.splice((i * this._rows) + perColumn, 0, { name: "" });
          }
        }

      }

    }
    this.setState({
      donorData: {
        donors: donorsSliced,
        name: cat.name
      }
    })

  }

  render() {
    if (!this.state.donorData) {
      return null
    }
    let sDims = {
      height: this.props.screen.sv.height,//1080,
      width: this.props.screen.sv.width//1920
    }
    let modifier = .6;
    sDims.fsTitle = sDims.height * 0.05556 * modifier; //60
    sDims.fsSubheader = sDims.height * 0.03333 * modifier; //36
    sDims.left = this.props.screen.sv.left

    // let debugBoxStyle = {
    //     position: 'absolute', 
    //     backgroundColor: 'black',
    //     opacity: .5,
    //     width: this.props.screen.screenWidth,
    //     height: this.props.screen.screenHeight / 2,
    //     top: 0,
    //     left: 0
    //  }

    return (
      <div className={this._fontClass} style={{ width: '100vw', height: '100vh', position: 'relative', color: this._fontColor }}>


        {/* <div style={debugBoxStyle} /> */}

        {/* Blue Backdrop */}
        <div style={{ position: 'absolute', left: sDims.left, top: 0, opacity: this._ni_options.backdropOpacity * .01, backgroundColor: this._backdropColor, width: sDims.width, height: sDims.height }} />

        {/* Temporary Full Page Background */}

        {/* {this.props.content.settings.custom_vars.custom1x2? <div style={{ position: 'absolute', left: sDims.left, top: 0, opacity: this._ni_options.backdropOpacity * .01, backgroundColor: this._backdropColor, width: sDims.width, height: sDims.height }}><VerticalVideoSync elementStateOverride={1} verticalWords={false} /></div>: null} */}


        {/* Title Divider Line*/}
        {this._ni_options.showTitleDivider ?
          <CSSTransitionGroup
            component='div'
            transitionName='slowfade'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.showDonors}>
              {this.state.showDonors ?
                <div style={{ position: 'absolute', left: sDims.width * .05 + sDims.left, top: this._titleDividerLineOffset.val, backgroundColor: this._fontColor, opacity: 1, width: sDims.width * .9, height: sDims.height * .0025 }} />
                :
                null}
            </div>
          </CSSTransitionGroup>
          :
          null}

        {/* Parent Category Name */}
        {this._ni_options.format.parent_category_name.visible ?
          <CSSTransitionGroup
            component='div'
            transitionName='slowfade'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.parentCategoryName} >
              <div style={{ ...this._parentCategoryNameStyle, position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._parentCategoryNameOffset.val, width: sDims.width * .9, height: sDims.height * .05 }}>
                <span>{this.state.parentCategoryName}</span>
              </div>
            </div>
          </CSSTransitionGroup>
          :
          null}

        {/* Sub Category Name */}
        {this._ni_options.format.sub_category_name.visible ?
          <CSSTransitionGroup
            component='div'
            transitionName='slowfade'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.subCategoryName} >
              <div style={{ ...this._subCategoryNameStyle, position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._subCategoryNameOffset.val, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 }}>
                <span>{this.state.subCategoryName}</span>
              </div>
            </div>
          </CSSTransitionGroup>
          :
          null}

        {/* Sub Category Subheader */}
        {this._ni_options.format.sub_category_subheader.visible ?
          <CSSTransitionGroup
            component='div'
            transitionName='slowfade'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.subCategorySubheader} >
              <div style={{ ...this._subCategorySubheaderStyle, position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._subCategorySubheaderOffset.val, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 }}>
                <span>{this.state.subCategorySubheader}</span>
              </div>
            </div>
          </CSSTransitionGroup>
          :
          null}

        {/* Sub Category Description */}
        {this._ni_options.format.sub_category_description.visible ?
          <CSSTransitionGroup
            component='div'
            transitionName='slowfade'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.subCategoryDescription} >
              <div style={{ ...this._subCategoryDescriptionStyle, position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._subCategoryDescriptionOffset.val, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 }}>
                <span>{this.state.subCategoryDescription}</span>
              </div>
            </div>
          </CSSTransitionGroup>
          :
          null}

        {/* Slides */}
        <CSSTransitionGroup
          component='div'
          transitionName='slowfade'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.cycleIndex} >
            {this.state.showSlides ?
              <div style={{ position: 'absolute', left: sDims.left, top: 0, opacity: 1, width: sDims.width, height: sDims.height }}>
                <img alt={"Slide"} src={this.state.slideImage} style={{ width: sDims.width, height: sDims.height }} />
              </div>
              :
              null}
          </div>
        </CSSTransitionGroup>

        {/* Donor name lists */}
        {this._ni_options.format.name_list.visible ?
          <CSSTransitionGroup
            component='div'
            transitionName='slowfade'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.cycleIndex} >
              {this.state.showDonors ?
                <div style={{ ...this._nameListStyle, position: 'absolute', left: 0, top: 0, opacity: 1, width: sDims.width, height: sDims.height }}>
                  {/* Donor Names*/}
                  <div style={{ position: 'absolute', left: sDims.left + sDims.width * .05, top: this._nameListOffset.val, width: sDims.width * .9, height: sDims.height * .8 }}>

                    {this.state.donorData ? 
                      <DonorFullPage
                        fontclass={this._ni_options.format.name_list.font}
                        height={this.props.module.contents.ni_options.format.name_list.height * .01 * this.props.screen.screenHeight}
                        width={sDims.width * .9}
                        rows={this._rows}
                        columns={this._columns}
                        donorData={this.state.donorData.donors}
                        screen={this.props.screen}
                        sort="column"
                        overrideFontSize={this._nameListStyle.fontSize}
                        overrideMarginRight={this._marginRight}
                        custom1x2={this.props.content.settings.custom_vars.custom1x2 ? true : false}
                      />
                      :
                      <span />
                    }
                  </div>
                  {this.props.module.contents.ni_options.format.footer_text.visible ?
                    <span style={{ ...this._footerTextStyle, left: sDims.width * .05 + sDims.left, marginRight: 0, position: 'absolute', width: sDims.width * .9, top: this._footerTextOffset.val }}>
                      <span>{this._footerText}</span>
                    </span>
                    :
                    null}
                </div>
                :
                null}
            </div>
          </CSSTransitionGroup>
          :
          null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let mod = state.content.dm_active[state.active_module];
  let isIdle = parseStringParam(window.location.href, "idle");
  if (isIdle === 'true') {
    mod = state.content.display_module_loops[0].display_module_loop_units[state.active_module].data; //.display_module.data
    mod = _.find(state.content.dm_active, { id: mod.id }); //TODO: should populate the module loop?
  }
  return {
    screen: state.screen,
    module: mod,
    donors: state.donors,
    content: state.content,
  };
};

export default connect(mapStateToProps, null)(DonorListPassive);



// WEBPACK FOOTER //
// ./src/Components/Donor/DonorListPassive.js